import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

export const useCustomModels = () => {
  const { workspaceId } = useParams();
  const authContext = useAuth();

  return useQuery({
    queryKey: ["custom-models", workspaceId],
    queryFn: () => {
      return fetch(ENDPOINTS.custom_models(workspaceId!), {
        method: "GET",
        headers: jsonAuthHeaders(authContext?.userToken!),
      }).then((res) => handleResponse(res));
    },
  });
};
